export const getExploreCardClassName = (baseClass, anchorId, highlightedAnchorId) => {
  const isSelected = Boolean(anchorId && highlightedAnchorId === anchorId);
  return `${baseClass} dashboard-explore-card${
    isSelected ? " dashboard-explore-card--selected" : ""
  }`;
};
